import { LayoutService } from 'src/app/core/services/layout.service';
import { SearchComponent } from './../search/search.component';
import { SidenavService } from 'src/app/core/services/sidenav.service';
import { AfterViewInit, ChangeDetectionStrategy, Component, OnInit, ViewChild } from '@angular/core';
import { AuthenticationService } from 'src/app/core/services/authentication.service';
import { PatientDialogService } from 'src/app/core/services/patient-dialog.service';

@Component({
  selector: 'app-header-primary',
  templateUrl: './header-primary.component.html',
  styleUrls: ['./header-primary.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush
})
export class HeaderPrimaryComponent implements OnInit, AfterViewInit {

  @ViewChild('search') search: SearchComponent;

  account$ = this.authService.account$;
  activateHandsetLayout$ = this.layoutService.activateHandsetLayout$;

  constructor(
    private authService: AuthenticationService,
    private patientDialogService: PatientDialogService,
    private sidenavService: SidenavService,
    private layoutService: LayoutService
  ) { }

  ngOnInit(): void {
  }

  ngAfterViewInit() {
  }

  addPatient() {
    this.patientDialogService.openPatientDialog().subscribe();
  }

  logout() {
    this.authService.logout();
  }

  toggleSidenav() {
    this.sidenavService.sidenav?.toggle();
  }

}
